import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 0 504 504"

const TumblrIcon = createSvgIcon(
  <>
    <g>
      <g>
        <path d='M377.6,0H126C56.8,0,0,56.8,0,126.4V378c0,69.2,56.8,126,126,126h251.6c69.6,0,126.4-56.8,126.4-126.4V126.4    C504,56.8,447.2,0,377.6,0z M312.4,405.2c-10.4,2.4-22,4-34,4c-13.6,0-22-2-32.8-5.6c-10.4-3.6-19.6-8.8-27.2-15.6    c-7.6-6.8-12-14-14.8-21.6c-2.8-7.6-3.6-18.4-3.6-32.8V224h-44v-44.8c12-4,26.4-9.6,34.8-17.2c8.4-7.6,15.6-16,20.8-26.4    c5.2-10.4,9.2-23.6,10.8-39.6H264v72h72v56h-72v80.4c0,18.4,0.4,28.8,2,34c2,5.2,6.8,10.4,11.6,13.6c6.8,4,15.2,6.4,23.6,6.4    c15.2,0,30.4-5.2,46.4-15.6V392h0.4C332,398.4,322.8,402.8,312.4,405.2z' />
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </>,
  'TumblrIcon'
)

export default TumblrIcon
